<div class="loading-circle" title="Loading">
	<!--   <h1>Loading</h1> -->
	<svg id="load" x="0px" y="0px" viewBox="0 0 180 180">
		<g
			id="loading"
			transform="translate(38.000000, 38.000000)"
			fill="#000000"
			fill-rule="nonzero"
			stroke-width="7"
		>
		<circle id="loading-inner" cx="52" cy="52" r="50"></circle>
		</g>
	</svg>
</div>
